/* lx1-award-badge.js: shows the right version of the LX1 gallery's award badge for the photo on screen - the dark-photo
   version (white text) over dark photos, the light-photo version (black text) over light ones.
   Used by snippets/lx1-award-badge.liquid (rendered in sections/lx1-pdp-hero.liquid); only loaded when both versions
   are set. Each photo's brightness is measured once, under the badge only, from a small copy of the image
   (Shopify's CDN allows this cross-origin read). The photo on screen is the main slider's .instant-slider-slide-active,
   which both instant-core and assets/moasure-lx1-runtime.js set, so it works whichever drives the slider.
   If a photo cannot be measured, the dark-photo version stays. */
(function () {
  var LIGHT_ABOVE = 128;  // mean luminance (0-255) under the badge above which a photo counts as light
  var SAMPLE_W = 120;     // width of the photo copy that gets measured

  function measure(src, badge, box) {
    return new Promise(function (resolve) {
      if (!src || src.indexOf('/cdn/shop/') === -1) return resolve(null);  // placeholders and non-Shopify images
      var url = new URL(src, location.href);
      url.searchParams.set('width', SAMPLE_W);
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onerror = function () { resolve(null); };
      img.onload = function () {
        try {
          var c = document.createElement('canvas');
          c.width = SAMPLE_W;
          c.height = Math.round(SAMPLE_W * img.naturalHeight / img.naturalWidth);
          var ctx = c.getContext('2d');
          ctx.drawImage(img, 0, 0, c.width, c.height);
          // the badge's rectangle, as a share of the photo box, mapped onto the sample. Its height comes from the
          // artwork's width/height attributes, so it is right even before the badge image has loaded.
          var b = badge.getBoundingClientRect(), r = box.getBoundingClientRect(), art = badge.querySelector('img');
          if (!r.width || !b.width) return resolve(null);
          var k = c.width / r.width, ratio = art.getAttribute('height') / art.getAttribute('width') || 1.5;
          var x = Math.max(0, Math.round((b.left - r.left) * k)), w = Math.max(1, Math.round(b.width * k));
          var h = Math.max(1, Math.min(c.height, Math.round(b.width * ratio * k)));
          var d = ctx.getImageData(x, 0, Math.min(w, c.width - x), h).data, sum = 0;
          for (var i = 0; i < d.length; i += 4) sum += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2];
          resolve(sum / (d.length / 4) > LIGHT_ABOVE);
        } catch (e) {
          resolve(null);
        }
      };
      img.src = url.href;
    });
  }

  function init(badge) {
    if (badge.hasAttribute('data-ready')) return;
    badge.setAttribute('data-ready', '');
    var box = badge.parentElement;
    var wrapper = box && box.querySelector('.instant-slider-wrapper');
    if (!wrapper) return;
    var slides = wrapper.children, light = [];

    function update() {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('instant-slider-slide-active')) {
          badge.setAttribute('data-tone', light[i] ? 'light' : 'dark');
          return;
        }
      }
    }

    new MutationObserver(update).observe(wrapper, { subtree: true, attributes: true, attributeFilter: ['class'] });
    Array.prototype.forEach.call(slides, function (slide, i) {
      var img = slide.querySelector('img');
      measure(img && (img.currentSrc || img.src), badge, box).then(function (isLight) {
        light[i] = isLight === true;
        update();
      });
    });
  }

  function run() {
    document.querySelectorAll('.lx1-award').forEach(function (badge) {
      if (badge.querySelector('.lx1-award__img--light')) init(badge);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
